export default __webpack_public_path__ + "static/media/img29.26745fca.jpg";